const STEPS = [
  {
    number: "01",
    label: "Order",
    title: "Place Your Order",
    description: "Submit your order online or call us. Provide basic information about the vehicle — make, model, year, and the seller's location.",
    icon: "ri-file-add-line",
  },
  {
    number: "02",
    label: "Schedule",
    title: "We Coordinate with the Seller",
    description: "We arrange a convenient inspection time directly with the seller. You don't have to do anything — we handle the scheduling for you.",
    icon: "ri-calendar-check-line",
  },
  {
    number: "03",
    label: "Inspect",
    title: "On-Site 450-Point Inspection",
    description: "Our technician travels to the vehicle's location and performs a complete 450-point mechanical, electrical, and physical inspection — including a test drive.",
    icon: "ri-car-line",
  },
  {
    number: "04",
    label: "Review",
    title: "Talk to Your Inspector",
    description: "Immediately after the inspection, your actual inspector calls you to review every finding. A detailed written report with photos is then emailed to you.",
    icon: "ri-user-voice-line",
  },
];

export default function ProcessSection() {
  return (
    <section className="bg-brand-black py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        {/* Header */}
        <div className="text-center mb-20">
          <p className="font-sans text-xs tracking-widest uppercase text-brand-gold mb-4 flex items-center justify-center gap-3">
            <span className="w-8 h-px bg-brand-gold" />
            How It Works
            <span className="w-8 h-px bg-brand-gold" />
          </p>
          <h2 className="font-serif text-4xl lg:text-5xl font-semibold text-brand-white leading-tight">
            Simple, Effortless Car Inspections
          </h2>
          <p className="font-sans text-base text-brand-gray mt-4 max-w-xl mx-auto">
            Four easy steps from order to full inspector consultation. We handle everything — you just make the call.
          </p>
        </div>

        {/* Desktop horizontal */}
        <div className="relative hidden lg:block">
          <div className="absolute top-10 left-[12%] right-[12%] h-px bg-gradient-to-r from-transparent via-brand-gold/40 to-transparent" />
          <div className="grid grid-cols-4 gap-8">
            {STEPS.map((step, i) => (
              <div key={i} className="flex flex-col items-center text-center">
                <div className="relative mb-8">
                  <div className="w-20 h-20 rounded-full border-2 border-brand-gold bg-brand-black flex flex-col items-center justify-center z-10 relative">
                    <div className="w-6 h-6 flex items-center justify-center">
                      <i className={`${step.icon} text-brand-gold text-xl`} />
                    </div>
                    <span className="font-sans text-xs font-bold text-brand-gold/60 mt-0.5">{step.number}</span>
                  </div>
                  <div className="absolute inset-0 rounded-full border border-brand-gold/20 scale-125" />
                </div>
                <p className="font-sans text-xs tracking-widest uppercase text-brand-gold mb-2">{step.label}</p>
                <h3 className="font-serif text-lg font-semibold text-brand-white mb-3">{step.title}</h3>
                <p className="font-sans text-sm text-brand-gray leading-relaxed">{step.description}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Mobile vertical */}
        <div className="lg:hidden flex flex-col gap-0">
          {STEPS.map((step, i) => (
            <div key={i} className="flex gap-5">
              <div className="flex flex-col items-center">
                <div className="w-14 h-14 rounded-full border-2 border-brand-gold bg-brand-black flex flex-col items-center justify-center shrink-0">
                  <div className="w-5 h-5 flex items-center justify-center">
                    <i className={`${step.icon} text-brand-gold text-base`} />
                  </div>
                </div>
                {i < STEPS.length - 1 && (
                  <div className="w-px flex-1 min-h-[36px] bg-brand-gold/20 my-2" />
                )}
              </div>
              <div className="pb-10 pt-1">
                <p className="font-sans text-xs tracking-widest uppercase text-brand-gold mb-1">{step.label}</p>
                <h3 className="font-serif text-xl font-semibold text-brand-white mb-2">{step.title}</h3>
                <p className="font-sans text-sm text-brand-gray leading-relaxed">{step.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
